import { useState } from 'react';

function useLocalStorage<T>(key: string, initialValue: T) {
  const getInitialValue = () => {
    if (globalThis.window === undefined) {
      return initialValue;
    }

    try {
      const item = globalThis.window.localStorage.getItem(key);
      if (item) {
        return JSON.parse(item);
      }

      globalThis.window.localStorage.setItem(key, JSON.stringify(initialValue));

      return initialValue;
    } catch {
      return initialValue;
    }
  };

  const [storedValue, setStoredValue] = useState(getInitialValue);

  const setValue = (value: T | ((val: T) => T)) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);

      if (globalThis.window !== undefined) {
        globalThis.window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch {}
  };

  return [storedValue, setValue] as const;
}

export default useLocalStorage;
